import { FaEnvira } from 'react-icons/fa';
import slate from '../packages/plugins/content/slate';

const defaultSlate = slate();

const environmentalWarningPlugin: any = {
  Renderer: ({ children, data }: any) => (
    <div
      className="environmentalWarning-content"
      style={{
        background: data?.backgroundColor ? data?.backgroundColor : '#98e27f',
        display: 'flex',
        padding: '9px 20px',
        borderRadius: '50px',
        minWidth: 500,
        maxWidth: '700px',
        alignItems: 'flex-start',
        margin: '10px auto',
      }}
    >
      <div
        className="environmentalWarning-icon"
        style={{
          fontSize: '40px',
          background: 'white',
          borderRadius: '50px',
          padding: '12px 12px 10px',
          marginTop: 18,
        }}
      >
        <FaEnvira />
      </div>
      <div
        className="environmentalWarning-text"
        style={{
          paddingLeft: 10,
          width: '90%',
          color: '#fff',
          paddingRight: 10,
        }}
      >
        {children}
      </div>
    </div>
  ),
  createInitialChildren: () => {
    return [
      [
        {
          plugin: defaultSlate,
          data: defaultSlate.createData(({ plugins }) => ({
            children: [
              {
                plugin: plugins.headings.h1,
                children: ['Environmental Note'],
              },
              {
                plugin: plugins.headings.h3,
                children: ['Subtitle'],
              },
              {
                plugin: plugins.headings.h4,
                children: ['Additional Text'],
              },
            ],
          })),
        },
      ],
    ];
  },

  id: 'environmentalWarning-plugin',
  title: 'Environmental Box',
  // description: 'emergency content plugin',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      required: ['backgroundColor'],
      properties: {
        backgroundColor: { type: 'string' },
      },
    },
  },
};

export default environmentalWarningPlugin;
